export const GENDERS_LIST = ['Male', 'Female'];
export const LANGUAGES_LIST = ["English", "Mandarin Chinese", "Hindi", "Spanish", "French", "Standard Arabic", "Bengali", "Portuguese", "Russian", "Urdu", "Indonesian", "German", "Japanese", "Swahili", "Marathi", "Telugu", "Turkish", "Korean", "Tamil", "Italian"
];
export const INDUSTRIES_LIST = ["Technology", "Healthcare", "Finance", "Retail", "Education", "Manufacturing", "Energy", "Telecommunications", "Real Estate", "Transportation", "Automotive", "Agriculture", "Hospitality", "Media and Entertainment", "Construction", "Pharmaceuticals", "Aerospace and Defense", "Food and Beverage", "Insurance", "Professional Services"
];

export const JOB_TYPE_LIST = ["Full Time", "Part Time"];

export const EDUCATION_LIST = ["B.A","B.Arch","B.B.A","B.Com","B.E/B.Tech","B.Ed","B.Pharm","B.Sc","BCA","BDS","BHM","BL/LLB","Diploma","ICWA","MBBS","CA","CS","M.A","M.Sc","M.Arch","M.Com","M.E/M.Tech/MS","M.Ed","M.Pharm","MBA","MCA","MD/MS","ML/LLM","PG Diploma","PGDM","PGDCA","Mphil","Phd","Aviation","Class 12","Other"];


export const CITY_LIST = [
    "Ahmedabad",
    "Bangalore",
    "Chennai",
    "Delhi",
    "Gurgaon",
    "Hyderabad",
    "Kolkata",
    "Mumbai",
    "Noida",
    "Pune",
    "Agartala",
    "Agra",
    "Ahmednagar",
    "Aizawal",
    "Ajmer",
    "Aligarh",
    "Allahabad",
    "Ambala",
    "Amritsar",
    "Anand",
    "Ankleshwar",
    "Asansol",
    "Aurangabad",
    "Bhagalpur",
    "Bareilly",
    "Baroda / Vadodara",
    "Belgaum",
    "Bellary",
    "Bharuch",
    "Bhatinda",
    "Bhavnagar",
    "Bhilaigarh",
    "Bhopal",
    "Bhubaneshwar",
    "Bhuj",
    "Bidar",
    "Bilaspur",
    "Bokaro",
    "Kozhikode / Calicut",
    "Chandigarh",
    "Coimbatore",
    "Cuttack",
    "Dalhousie",
    "Daman",
    "Dehradun",
    "Dhanbad",
    "Dharamsala",
    "Dharwad",
    "Dispur",
    "Durgapur",
    "Erode",
    "Faizabad",
    "Faridabad",
    "Gandhinagar",
    "Gangtok",
    "Ghaziabad",
    "Goa",
    "Gorakhpur",
    "Gulbarga",
    "Guntur",
    "Guwahati",
    "Gwalior",
    "Haldia",
    "Hisar",
    "Hosur",
    "Hubli",
    "Imphal",
    "Indore",
    "Itanagar",
    "Jabalpur",
    "Jaipur",
    "Jaisalmer",
    "Jalandhar",
    "Jalgaon",
    "Jammu",
    "Jamnagar",
    "Jamshedpur",
    "Jodhpur",
    "Kakinada",
    "Kandla",
    "Kannur",
    "Kanpur",
    "Karnal",
    "Kavaratti",
    "Kharagpur",
    "Cochin / Kochi / Ernakulam",
    "Kohima",
    "Kolar",
    "Kolhapur",
    "Kollam",
    "Kota",
    "Kottayam",
    "Kulu/Manali",
    "Kurnool",
    "Kurukshetra",
    "Lucknow",
    "Ludhiana",
    "Madurai",
    "Mangalore",
    "Mathura",
    "Meerut",
    "Mohali",
    "Moradabad",
    "Mysore",
    "Nagercoil",
    "Nagpur",
    "Nasik",
    "Nellore",
    "Nizamabad",
    "Ooty",
    "Pallakad",
    "Panipat",
    "Paradeep",
    "Pathankot",
    "Patiala",
    "Patna",
    "Pondicherry",
    "Porbandar",
    "Port Blair",
    "Puri",
    "Quilon",
    "Raipur",
    "Rajamundry",
    "Rajkot",
    "Ranchi",
    "Rohtak",
    "Roorkee",
    "Rourkela",
    "Salem",
    "Shillong",
    "Shimla",
    "Sholapur",
    "Silchar",
    "Siliguri",
    "Silvassa",
    "Srinagar",
    "Surat",
    "Thanjavur",
    "Thrissur / Trissur",
    "Tirunalveli",
    "Tirupati",
    "Thiruvananthapuram / Trivandrum",
    "Trichy",
    "Tuticorin",
    "Udaipur",
    "Ujjain",
    "Valsad",
    "Vapi",
    "Varanasi",
    "Vellore",
    "Vijayawada",
    "Visakhapatnam",
    "Warangal",
    "Alappuzha / Alleppey",
    "Idukki",
    "Kasargod",
    "Malappuram",
    "Pathanamthitta",
    "Wayanad",
    "Sonipat / Sonepat",
    "Yamunanagar",
    "Shimoga",
    "Baddi",
    "Panchkula"
];
